import { updateObject } from 'store/utility';
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    works: {},
    complete: {},
    objects: {},
    objectsObj: {},
    items: {},
    itemsObj: {},
    search: {},
    priref: {},
    fulltext: {}, 
    doSearch: false,
    limit: {
        work: 20,
        object: 20,
        person: 20
    },
    offset: {
        work: 0,
        object: 0,
        person: 0
    },
    sort: {
        work: { field: "title", dir: "ASC" },
        object: { field: "archive_number", dir: "ASC" }
    },
    count: {
        work: 0,
        object: 0
    },
    selected: {
        work: {},
        object: {}
    },
    section: "work"
}
const sdkSearchSucces = (state, action) => {
    const fulltext = { ...state.fulltext, ...action.fulltext };
    const search = { ...state.search, ...action.search }
    const offset = { ...state.offset }
    offset[action.section] = 0;
    
    return updateObject(state, { search: search, section: action.section, fulltext: fulltext, offset: offset, doSearch: true });
}

const sdkSetLimit = (state, action) => {
    const limit = { ...state.limit }
    limit[action.section] = action.limit;
    const offset = { ...state.offset }
    offset[action.section] = 0;
    return updateObject(state, { limit: limit, offset: offset, doSearch: true });
}

const onSelect = (state, action) => {
    const selected = { ...state.selected }
    if(action.obj.id in selected[action.section]) {
        delete selected[action.section][action.obj.id];
    } else {
        selected[action.section][action.obj.id] = action.obj;
    }
    
    return updateObject(state, { selected: selected });
}

const CutReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SDK_WORK_GET_SUCCESS:
            let works = state.count;
            works["work"] = action.count;
            return updateObject(state, { works: action.works, count: works, doSearch: false });
        case actionTypes.SDK_OBJECT_GET_SUCCESS:
            let objects = state.count;
            objects["object"] = action.count;
            let oPriref = state.priref;
            if(action.priref) {
                oPriref[action.priref] = action.id;
            }
            return updateObject(state, { objects: action.objects, objectsObj: action.objectsObj, count: objects, doSearch: false, priref: oPriref });
        case actionTypes.SDK_ITEM_GET_SUCCESS:
            //let objects = state.count;
            //objects["object"] = action.count;
            let iPriref = state.priref;
            if(action.priref) {
                iPriref[action.priref] = action.id;
            }
            return updateObject(state, { items: action.items, itemsObj: action.itemsObj, priref: iPriref });
        case actionTypes.SDK_SEARCH_SUCCESS:
            return sdkSearchSucces(state, action);
        case actionTypes.SDK_WORK_GET_ONE_SUCCESS:
            let complete = state.complete;
            let wPriref = state.priref;
            if(action.priref) {
                wPriref[action.priref] = action.id;
            }
            complete[action.id] = action.work;
            console.log(action.work);
            return updateObject(state, { complete: complete, priref: wPriref });
        case actionTypes.SDK_SET_LIMIT:
            return sdkSetLimit(state, action);
        case actionTypes.SDK_SET_SORT:
            const sort = { ...state.sort }
            sort[action.section] = action.sort;
            return updateObject(state, { sort: sort, doSearch: true });
        case actionTypes.SDK_SET_OFFSET:
            const offset = { ...state.offset }
            offset[action.section] = action.offset;
            return updateObject(state, { offset: offset, doSearch: true });
        case actionTypes.SDK_ON_SELECT:
            return onSelect(state, action);
        default:
            return state;
    }
}

export default CutReducer;
